<template>
  <h3>{{animatedNumber}}</h3>
</template>

<script>
  import TWEEN from '@tweenjs/tween.js'

  export default {
    name: 'animated-counter',
    props: ['number'],
    data () {
      return {
        animatedNumber: 0
      }
    },
    methods: {
      updateCounter (newValue, oldValue) {
        const animate = () => {
          if (TWEEN.update()) {
            requestAnimationFrame(animate)
          }
        }

        let obj = {tweeningNumber: oldValue}
        new TWEEN.Tween(obj)
          .to({tweeningNumber: newValue}, 500)
          .easing(TWEEN.Easing.Quadratic.Out)
          .onUpdate(() => {
            this.animatedNumber = obj.tweeningNumber.toFixed(0)
          })
          .start()
        animate()
      }
    },
    watch: {
      number (newValue, oldValue) {
        this.updateCounter(newValue, oldValue)
      }
    },
    mounted () {
      this.updateCounter(this.number, 0)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/settings/alert/AnimatedCounter.vue